export const FILTER_ITEM_CHECK = 'casinoFilter_checkbox_check';
export const FILTER_ITEM_UNCHECK = 'casinoFilter_checkbox_uncheck';
